module.exports = __webpack_public_path__ + "static/img/weask_logo.5ddeddd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/weask_logo.png
// module id = ozIh
// module chunks = 1